import { createFileRoute } from "@tanstack/react-router";

import { Header } from "../components/site/Header";
import { Footer } from "../components/site/Footer";
import { Hero } from "../components/home/Hero";
import { Showreel } from "../components/home/Showreel";
import { Cases } from "../components/home/Cases";
import { Services } from "../components/home/Services";
import { Approach } from "../components/home/Approach";
import { Principles } from "../components/home/Principles";
import { ClientsMarquee } from "../components/shared/ClientsMarquee";
import { ContactForm } from "../components/home/ContactForm";
import { SpecialOffer } from "../components/home/SpecialOffer";
import { SellerPromo } from "../components/seller/SellerPromo";
import { Team } from "../components/home/Team";
import { AutoScale } from "../components/site/AutoScale";
import { ScrollToTop } from "../components/site/ScrollToTop";
import { buildMeta, SITE_URL } from "../lib/site";


const title = "Маркетинговое агентство HAY — сайты, реклама, CRM и ИИ";
const description =
  "Маркетинговое агентство HAY.agency: сайты и e-commerce, SEO, Яндекс Директ, продвижение в Картах, CRM и веб-сервисы. Используем ИИ в аналитике, маркетинге и разработке.";


export const Route = createFileRoute("/")({
  head: () => ({
    ...buildMeta({
      title,
      description,
      path: "/",
      image: `${SITE_URL}/og/home.webp`,
      imageWidth: 1200,
      imageHeight: 630,
      imageAlt: "HAY.agency — маркетинговое агентство",
      locale: "ru_RU",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id": `${SITE_URL}/#webpage`,
          url: `${SITE_URL}/`,
          name: title,
          description,
          isPartOf: { "@id": `${SITE_URL}/#website` },
          about: { "@id": `${SITE_URL}/#organization` },
          publisher: { "@id": `${SITE_URL}/#organization` },
        }),
      },
    ],
  }),
  component: Index,
});


function Index() {
  return (
    <AutoScale>
      <div className="home-page-shell min-h-screen bg-background font-sans text-foreground antialiased">
        <SpecialOffer />
        <Header />
        <main>
          <Hero />
          <SellerPromo />
          <Showreel />
          <Cases />
          <Services />
          <Team />
          <ClientsMarquee />
          <Approach />
          <Principles />
          <ContactForm />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </AutoScale>
  );
}
